import { type CollabViewSortType } from '@databases/model/views/view-sort';
import { defaultStoreUtils } from '@databases/redux';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import { getDatabaseFieldOptional } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';

import { hasUnresolvedJiraEntries } from './useJiraFilterLoading';
import useView from './useView';

function extractJiraSortFieldIds(
  sorts: CollabViewSortType[],
  database: Database
): string[] {
  const jiraFieldIds: string[] = [];

  for (const sort of sorts) {
    const field = getDatabaseFieldOptional(database, sort.fieldId);
    if (field?.type === DatabaseFieldType.JIRA_ISSUE_DETAILS) {
      jiraFieldIds.push(sort.fieldId);
    }
  }

  return jiraFieldIds;
}

export function useJiraSortLoading(contentId: string): boolean {
  const { view } = useView();
  const sorts = view.settings.sorts;

  const isLoading = defaultStoreUtils.useEqualSelector((state) => {
    if (!sorts || sorts.length === 0) {
      return false;
    }

    const database = selectDatabaseByContentIdRequired(state, { contentId });
    const jiraFieldIds = extractJiraSortFieldIds(sorts, database);

    if (jiraFieldIds.length === 0) {
      return false;
    }

    return hasUnresolvedJiraEntries(database, jiraFieldIds, state);
  });

  return isLoading;
}
